import { render, staticRenderFns } from "./ItemTypes.vue?vue&type=template&id=f86616cc"
import script from "./ItemTypes.vue?vue&type=script&lang=js"
export * from "./ItemTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports